<div class="wrapper">
  <div
    class="label"
    msl-fit-text
    [innerHTML]="currentLabel | translate"
    [ngStyle]="{ color: operator.appearance.colors.border }"
  ></div>
</div>
